module.exports = __webpack_public_path__ + "static/media/Swift.9330e48c.png";